import { type Pagination, type UserList, createUserList } from 'models';
import { useInfiniteQuery } from 'query';
import { getProgramsUsers } from '../services';
import type { ProgramsUsersListFilter } from '../types';
import { getProgramUsersInfiniteQueryKey } from './keys';

type P = {
  filter: ProgramsUsersListFilter;
  pagination: Omit<Pagination, 'position'>;
};

export const useProgramsUsersInfiniteQuery = ({ filter, pagination }: P) =>
  useInfiniteQuery<UserList[], string | undefined>({
    async queryFn({ pageParam: cursor }) {
      const usersResponse = await getProgramsUsers({
        config: {
          params: { cursor, limit: pagination.pageSize, search: filter.search, sort: filter.sort },
        },
        routeParams: {
          id: filter.programId,
        },
      });

      // TODO: there are also other data in the `userResponse` besides users
      return usersResponse.data.users.map((user) => createUserList(user));
    },
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => (lastPage.length < pagination.pageSize ? undefined : lastPage.at(-1)?.id),
    queryKey: getProgramUsersInfiniteQueryKey({ filter, pagination }),
    refetchOnMount: 'always',
  });
